import styled from 'styled-components'
import * as spacing from 'styles/spacing'
import { mediaDown } from '../../../styles/media'
import { buttonBackColor } from 'styles/colors'

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 25px;
  z-index: 450;
  padding: ${spacing.medium};
  display: flex;
`

export const PreviewContainer = styled.div`
  width: 100vw;

  height: 100vh;

  display: flex;

  justify-content: center;

  align-items: center;

  flex-direction: column;

  background-color: #000;
`

export const PreviewImage = styled.img`
  width: 90%;

  max-height: 50vh;

  object-fit: contain;

  border-radius: 10px;
  ${mediaDown.small`max-height:70vh`};
`
export const CropperWrap = styled.div`
  height: 50%;
`

export const ActionButtonWrapper = styled.div`
  margin-top: 3%;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaDown.large`margin-top:15%;`};
`
export const ButtonContainer = styled.div`
  width: 100%;
`

export const Header = styled.h1`
  color: ${buttonBackColor};
  text-align: center;
  padding: 10px;
`
export const Helper = styled.h5`
  color: ${buttonBackColor};
  text-align: center;
  padding: 10px;
`

export const Error = styled.h3`
  margin-top: 2%;
  color: red;
`
